<template>
    <div class="whole">
        <div class="background q-mx-xl q-my-xl">
            <div class="q-mx-xl q-ml-xl">
                <div class="title q-mt-xl">
                    <h5 class="q-mb-lg q-mt-xl">We are sorry to see you go!</h5>
                </div>
                <div class="subtitle">
                    <p>
                        Please review your opinion below to modify your preferences
                    </p>
                </div>


                <form method="post" id="contactForm" ref="contactForm" name="contactForm">
                    <ol>
                        <li>Please let us know why you unsubscribed:? <span style="color:red">*</span></li>
                        <p style="font-size:12px;color:red" v-if="error == true">Please select one reason</p>
                        <div class="q-gutter-md q-mb-md ">
                            <q-radio v-model="customerFeedback1" val="No sales increase for our seller account"
                                label="No sales increase for our seller account"></q-radio> <br>
                            <q-radio v-model="customerFeedback1" val="Not professional
" label="Not professional"></q-radio> <br>
                            <q-radio v-model="customerFeedback1" val="Bad User experience"
                                label=" Bad User experience"></q-radio> <br>
                            <div class="row"> <q-radio val="other" label="Other , " class="q-mr-md"
                                    v-model="customerFeedback1"></q-radio> <q-input v-model="customerFeedback3"
                                    :dense="dense"></q-input></div>

                        </div>
                        <li>What would have made you stay?</li>
                        <div class="q-gutter-md q-ml-sm q-mt-sm" style="max-width: 900px">
                            <q-input outlined v-model="customerFeedback2"></q-input>
                            <div class="unsubscribe q-mt-md">
                                <q-btn class="button-uns" @click="unSubscribe">
                                    Unsubscribe
                                </q-btn>
                            </div>
                        </div>
                    </ol>
                </form>
            </div>

        </div>


    </div>

</template>
<style>
.whole {
    height: 100%;
    width: 100%;
}

.background {
    background-color: white;
    height: 620px;
}

.title {

    justify-content: center;
    display: flex;

}

.title h5 {

    color: #102689;
    font-size: 35px;
    font-style: italic;
    margin-bottom: 20px;
}

.subtitle {
    justify-content: center;
    display: flex;
    color: steelblue;
    font-size: 20px;
    margin-bottom: 10px;
}

.whole li {
    font-size: 16px;
}

.button-uns {
    background-color: #102689;
    color: white;
    justify-content: center;
    display: flex;

    font-weight: bold;
}
</style>
<script>


export default {

    data() {
        return {
            api_url: this.$store.state.API_URL[process.env.VUE_APP_ENV],
            customerFeedback: [],
            text: " ",
            dense: true,
            values: "",
            user_id: this.$store.state.credentials['attributes']['email'],

            customerFeedback1: '',
            customerFeedback2: '',
            customerFeedback3: '',
            error: false,


        }



    },
    methods: {
        customer_feedBack() {
            if (this.customerFeedback3 == '') {
                return [
                    {


                        customerFeedback1: this.customerFeedback1,
                        customerFeedback2: this.customerFeedback2,

                    },
                ]
            }
            else {
                return [
                    {


                        customerFeedback1: this.customerFeedback3,
                        customerFeedback2: this.customerFeedback2,

                    },
                ]
            }
        },

        unSubscribe() {
            this.$mixpanel.track('Cancel/Unsubscription',{
                info : 'User Unsubscribed'
            })

            if (this.customerFeedback1 == '' && this.customerFeedback3 == '' || this.customerFeedback1 == 'other' && this.customerFeedback3 == ''||this.customerFeedback1 != 'other' && this.customerFeedback3 != '' ) {
                this.error = true;
            }
            else {

                this.$q.loading.show({});
                console.log(this.customerFeedback1)
                let postURL = this.api_url + '/products/unsubscribe';
                this.$http.post(postURL, this.customer_feedBack()).then((response) => {
                    console.log(response);
                    this.$q.loading.hide();
                    if (response.data == "Unsubscribed") {
                        this.$q.notify({
                            type: 'positive',
                            message: 'Thank You! Successfully submitted your feedback ',
                            position: 'center',
                            
                        })
                        this.customerFeedback1 = '',
                        this.customerFeedback2 = '',
                        this.customerFeedback3 = '',


                        setTimeout(() => {
                            window.location.href = "https://app-test.uniqin.ai"
                        }, 2900)

                    }



                })
                    .catch((error) => {
                        this.$q.notify({
                            type: 'negative',
                            message: 'error'
                        })
                    });

            }
        },










    }

}


</script>